module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"video_upload_error":{"default":"Failed to upload the video.","too_large":"Videos up to 500MB can be uploaded.","invalid_type":"This is not a video file."},"video_create_error":{"default":"An error occurred while uploading the video."}}}')
  delete Component.options._Ctor
}
